import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./ModuleFooter.scss";

export interface IModuleFooterProps {
    visible?: boolean;
    floating?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export class ModuleFooter extends Component<IModuleFooterProps> {
    public render() {
        const { visible, floating, className, children } = this.props;
        return (
            <div
                className={classnames(
                    styles["module-footer"],
                    floating && styles.floating,
                    visible && styles.visible,
                    className,
                )}
            >
                {children}
            </div>
        );
    }
}
